import React from 'react'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'
import PriceInput from '../inputs/price-input'

const PaymentSection = ({getValues, setValue, register, control, errors}) => {
  const currency = getValues('currency')
  const currencyName = currency == 'usd' ? '' : ` (${currency.toUpperCase()})`
  const requiredMsg = 'Is required'
  const paymentTypes = { 
    'registration': 'Registration Payment',
    'both': 'Registration + Per Game Payment',
    'per_game': 'Per Game Payment',
  }
  const paymentTypeDescriptions = { 
    'registration': 'One-time payment. Once the registration payment is made, participants are considered registered for the league.',
    'both': 'Registration one-time payment as well as a payment per team for each league game.',
    'per_game': 'Participants are considered registered for the league just by completing the registration form. Then, a payment per team for each league game will be collected.',
  }

  const currentType = () => {
    return getValues('payment_type') || 'registration'
  }

  const checkedClass = (type) => {
    return (currentType() == type) ? ' checked' : ''
  }

  const paymentTypeDescription = () => {
    return paymentTypeDescriptions[currentType()]
  }

  const teamRegField = () => {
    return <PriceInput
      {...register('team_reg_cost', { required: requiredMsg })}
      label={`Team Registration Cost${currencyName}`}
      key={1}
      error={errors.team_reg_cost}
      onChange={(e) => setValue('team_reg_cost', e.target.value)}
    />
  }

  const indRegField = () => {
    return <PriceInput
      {...register('individual_reg_cost', { required: requiredMsg })}
      label={`Free Agent Registration Cost${currencyName}`}
      key={2}
      error={errors.individual_reg_cost}
      onChange={(e) => setValue('individual_reg_cost', e.target.value)}
    />
  }

  const perGameField = () => {
    return <PriceInput
      {...register('game_cost', { required: requiredMsg })}
      label={`Cost Per Game/Team${currencyName}`}
      key={3}
      error={errors.game_cost}
      onChange={(e) => setValue('game_cost', e.target.value)}
    />
  }

  const paymentTypeFields = () => {
    switch (currentType())
    {
      case 'registration':
        return [teamRegField(), indRegField()]
      case 'both':
        return [teamRegField(), indRegField(), perGameField()]
      case 'per_game':
        return perGameField()
      default: 
        return []
    }
  }

  return <Controller
    control={control}
    name='payment_type'
    render={({ field }) => {
      return <div className='payment-section'>
        <div className='payment-section__title'>
          { 
            Object.keys(paymentTypes).map((type, i) => {
              return <div key={i} className={`payment-type ${type}`} onClick={() => field.onChange(type)}>
                <div className={`payment-check` + checkedClass(type)}></div>
                <div className='payment-title'>{paymentTypes[type]}</div>
              </div>
            })
          }
        </div>
        <div className='payment-section__body'>
          <div className='payment-type-description'>{paymentTypeDescription()}</div>
          <div className='payment-type-fields'>{paymentTypeFields()}</div>
        </div>
      </div>
    }}
  />
}

PaymentSection.propTypes = {
  getValues: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  register: PropTypes.func.isRequired,
  control: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
}

export default PaymentSection
